import { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import api from "../../services/api";

export default function ManageBlocks(){

const [blocks,setBlocks] = useState([]);
const [name,setName] = useState("");

const [editId,setEditId] = useState(null);
const [editName,setEditName] = useState("");


/* Load Blocks */

const loadBlocks = () => {

api.get("/admin/blocks")
.then(res => setBlocks(res.data))
.catch(err => console.log(err));

};

useEffect(()=>{
loadBlocks();
},[]);


/* Add Block */

const addBlock = async () => {

if(!name) return;

await api.post("/admin/blocks",{name});

setName("");
loadBlocks();

};


/* Delete Block */

const deleteBlock = async (id) => {

if(!window.confirm("Delete this block?")) return;

await api.delete(`/admin/blocks/${id}`);

loadBlocks();

};


/* Start Edit */

const startEdit = (block) => {

setEditId(block.id);
setEditName(block.name);

};


/* Update Block */

const updateBlock = async () => {

await api.put(`/admin/blocks/${editId}`,{
name:editName
});

setEditId(null);
setEditName("");

loadBlocks();

};


return(

<div className="min-h-screen bg-gray-50">

<Navbar/>

<div className="max-w-4xl mx-auto p-10">

<h2 className="text-2xl font-bold mb-6">
Manage Blocks
</h2>


{/* Add Block */}

<div className="flex gap-4 mb-8">

<input
value={name}
onChange={e=>setName(e.target.value)}
placeholder="Block name"
className="border p-2 flex-1 rounded"
/>

<button
onClick={addBlock}
className="bg-blue-600 text-white px-4 py-2 rounded"
>
Add Block
</button>

</div>


{/* Block List */}

<div className="bg-white shadow rounded">

{blocks.map(b=>(

<div
key={b.id}
className="flex justify-between items-center border-b p-4"
>

{editId === b.id ? (

<input
value={editName}
onChange={e=>setEditName(e.target.value)}
className="border p-2 flex-1 mr-4"
/>

) : (

<span className="font-medium">
{b.name}
</span>

)}


<div className="flex gap-2">

{editId === b.id ? (

<>
<button
onClick={updateBlock}
className="bg-blue-600 text-white px-3 py-1 rounded"
>
Save
</button>

<button
onClick={()=>setEditId(null)}
className="bg-gray-400 text-white px-3 py-1 rounded"
>
Cancel
</button>
</>

) : (

<>
<button
onClick={()=>startEdit(b)}
className="bg-yellow-500 text-white px-3 py-1 rounded"
>
Edit
</button>

<button
onClick={()=>deleteBlock(b.id)}
className="bg-red-600 text-white px-3 py-1 rounded"
>
Delete
</button>
</>

)}

</div>

</div>

))}

</div>

</div>

</div>

)

}